import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vue-select/dist/vue-select.css';
import './css/estilos.css';

import vSelect from 'vue-select'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.prototype.$swal = Swal

Vue.component('vue-select', vSelect)

//axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

//socket.io-client
import io from 'socket.io-client';

//datetime picker
import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker)

// google charts
import VueGoogleCharts from 'vue-google-charts'
Vue.use(VueGoogleCharts)

Vue.config.productionTip = false

// Validaciones
Vue.use(Vuelidate);

// Vue Mask
import VueMask from 'v-mask';
Vue.use(VueMask);

//mis modificaciones
window.Event = new Vue();
Vue.prototype.$buscarObjeto = async function(id,array){
   let objetos = await array.filter((obj)=>{
     if(obj.id == id){
       return obj
     }
   })
   //console.log('objetos_encontradooos',objetos);
   return objetos[0]
}

Vue.prototype.$tienePermiso = function(nombrePermiso) {
  return this.$store.state.permissions.includes(nombrePermiso);
}

Vue.prototype.errorMessage = function(e, msge="Error"){
    console.log('error', e);
    this.ocultarLoading();
    if (e.response){
        this.mostrarLoading({titulo:`${msge}... ${e.response.data.message}`, color:'#ff5252'});
    } else {
        this.mostrarLoading({titulo:`${msge} ... ${e}`, color:'#ff5252'});
    }
}

//redondeo
Vue.prototype.redondear = (valor, precision) =>{
  var multiplicador = Math.pow(10, precision || 0);
  // console.log(`numero redondeado: ${Math.round(value * multiplier) / multiplier}`);
  return Math.round(valor * multiplicador) / multiplicador;
}

//formater miles
Vue.filter('formatear_miles',function (valor){
  if(!valor) return '0'
  if(typeof valor == 'string'){
      
      valor = Number(valor);
  }
  let result = valor.toLocaleString("es-CL",{minimumFractionDigits: 0, maximumFractionDigits: 0});
  return result;
})


//uso de moment
import moment from 'moment'

Vue.prototype.moment = moment;
Vue.filter('formatearFecha', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY')
  }
})
Vue.filter('formatearHora', function(value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
})
Vue.filter('fechaCompleta', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm')
  }
})
Vue.filter('diaHora', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MM HH:mm')
  }
})


//fin mis modificaciones

// Vue.prototype.base_url = 'http://192.168.1.174/produccion-plp/backend/public/api/';

Vue.prototype.socket = io(store.state.url_socket,{ autoConnect: false });

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  watch: {
    '$route':{
      handler: (to, from) => {
        document.title = to.meta.title || 'Sistema Produccion PLP'
      },
       immediate: true
    }
  },
}).$mount('#app')
